import React, { Component } from 'react';
import './homework.scss';
import { ImageConstants, AccessRights } from '../../constants/constants';
import { getImageSource } from '../../utility/image-source'
import HomeworkList from './homework-list/homework-list'
import NewHomework from './new-homework/new-homework'

import SessionCache from '../routes/session-cache';
class Homework extends Component {
    state = {
        showHomeworkList: true
    }

    selectedHomeworkType = "STANDARD"

    accessRights = SessionCache.getAllowedModule()
    constructor(props) {
        super(props)
        console.log(window.location.pathname);
        const paths = window.location.pathname.split("/")
        console.log(paths[paths.length - 1])
        if(paths[paths.length - 1] === "adaptive") {
            this.selectedHomeworkType = "ADAPTIVE"
            this.state.showHomeworkList = true
        } else {
            this.selectedHomeworkType = "STANDARD"
            this.state.showHomeworkList = true
        }
    }
    componentDidMount() {

      
        if (this.props?.location?.showList) {
            this.setState({
                showHomeworkList: true
            })
        }

       

    }

    componentDidUpdate (prevProps, prevState) {
        // update state 
        console.log(prevProps.location.pathname)
        console.log(this.props.location.pathname)
        if(prevProps.location.pathname !== this.props.location.pathname){
            const paths = window.location.pathname.split("/")
            console.log(paths[paths.length - 1])
            if(paths[paths.length - 1] === "adaptive") {
                this.selectedHomeworkType = "ADAPTIVE"
                this.state.showHomeworkList = true
            } else {
                this.selectedHomeworkType = "STANDARD"
                this.state.showHomeworkList = true
            }
            this.setState({
                showHomeworkList: false
            }, _ => {
                this.setState({
                    showHomeworkList: true
                })
            })
        }
    }
      

    onSelectHomework = (type) => {
        this.selectedHomeworkType = type
        this.setState({ showHomeworkList: true })
    }

    handleGoBack = () => {
        this.setState({ showHomeworkList: false })
    }

    showNewHomework = () => {
        this.setState({ showNewHomework: true })
    }

    hideNewHomework = () => {
        this.setState({ showNewHomework: false })
    }

    render() {

        if (this.state.showNewHomework)
            return <NewHomework type={this.selectedHomeworkType} delegate={this} back={this.hideNewHomework} />

        if (this.state.showHomeworkList)
            return <HomeworkList type={this.selectedHomeworkType} delegate={this} back={this.handleGoBack} filter={this.props.filter} />

        return (
            <div className='homework'>
                <span className='screen-title'>Homework</span>
                {
                    this.accessRights[AccessRights.STANDARD_HOMEWORK_VIEW] ?
                        <div className='cw-plain-card cw-plain-card-wrapper mt-4 cursor-pointer' onClick={() => this.onSelectHomework('STANDARD')}>

                            <div className='row'>
                                <div className='col-1'>
                                    <div className='icon-wrapper'>
                                        <img className='homework-icon' src={getImageSource(ImageConstants.STANDARD_HOMEWORK)} />
                                    </div>
                                </div>

                                <div className='col-9 justify-center'>
                                    <div className='sub-title'>Homework</div>
                                    <span className='pt-3'>Student attempts all the questions in one go followed by learning</span>
                                </div>

                                <div className='col-2 align-center'>
                                    <img className='right-arrow' src={getImageSource(ImageConstants.RIGHT_ARROW)} />
                                </div>
                            </div>


                        </div> : ""
                }
                {this.accessRights[AccessRights.ADAPTIVE_HOMEWORK_VIEW] ?
                    <div className='cw-plain-card cw-plain-card-wrapper mt-4 cursor-pointer' onClick={() => this.onSelectHomework('ADAPTIVE')}>
                        {/* <div className='cw-plain-card cw-plain-card-wrapper mt-4 cursor-pointer'> */}

                        <div className='row'>
                            <div className='col-1'>
                                <div className='icon-wrapper'>
                                    <img className='homework-icon' src={getImageSource(ImageConstants.ADAPTIVE_HOMEWORK)} />
                                </div>
                            </div>

                            <div className='col-9 justify-center'>
                                <div className='sub-title'>Personalised Homework</div>
                                <span className='pt-3'>Student do questions & learning together for each ELO, one after other</span>
                            </div>

                            <div className='col-2 align-center'>
                                {/* <span className="coming-soon">COMING SOON</span> */}
                                <img className='right-arrow' src={getImageSource(ImageConstants.RIGHT_ARROW)} />
                            </div>
                        </div>
                    </div> : ""
                }
            </div >);
    }
}

export default Homework;